// Dynamic Skew
function updateSkew() {
    const vw = window.innerWidth;

    // Default skew values
    const minSkew = 1;
    const maxSkew = 20;
    const skewMultiplier = 0.006;
    const translateX = -5; // Define translateX as needed, e.g., 10

    // Calculate the skew value based on viewport width and custom multiplier
    let skewValue = vw * skewMultiplier;

    // Ensure the skewValue is within the specified range
    if (skewValue < minSkew) {
        skewValue = minSkew;
    } else if (skewValue > maxSkew) {
        skewValue = maxSkew;
    }

    // Select all elements with the class .skew-positive
    const skewPositiveElements = document.querySelectorAll('.skew-positive');
    
    skewPositiveElements.forEach(element => {
        // Apply only skew transformation to .skew-positive elements
        element.style.transform = `skewX(${skewValue}deg)`;
    });

    // Select all content containers with the class .skew-negative
    const skewNegativeContainers = document.querySelectorAll('.skew-negative');
    
    skewNegativeContainers.forEach(container => {
        // Apply skew and possibly translateX to .skew-negative elements
        const parentSection = container.closest('section.signposting, section.text-and-image-section');
        if (parentSection) {
            container.style.transform = `skewX(${-skewValue}deg) translateX(${translateX}vw)`;
        } else {
            container.style.transform = `skewX(${-skewValue}deg)`;
        }
    });
}

// Update skew on window resize
window.addEventListener('resize', updateSkew);
document.addEventListener('DOMContentLoaded', updateSkew);
